import React, { useState } from 'react'
import ToastService from 'services/toast.service'

import { CardType } from 'types/deck'

import CollapsibleContentContainer from 'components/elements/CollapsibleContentContainer'
import ArchidektDropdown from 'components/elements/ArchidektDropdown'

import styles from './contentBlock.module.scss'
import BuyBulkModal from 'components/deckPage/modals/BuyBulk'

type ContentBlockProps = {
  name: string
  listLength: number
  defaultCollapsed: boolean
  children: React.ReactNode
  deckAName: string
  deckBName: string
  cards?: CardType[]
  skipQuantities?: boolean
  className?: string
}

const ContentBlock = ({
  name,
  listLength,
  defaultCollapsed,
  children,
  className = styles.cardContainer,
  cards,
  skipQuantities,
  deckAName,
  deckBName,
}: ContentBlockProps) => {
  const [bulkBuyOpen, setBulkBuyOpen] = useState(false)

  const handleCopyCardNames = (includeQuantities: boolean) => {
    if (!cards) return

    let text = ''

    for (const card of cards) {
      text += includeQuantities ? `${card.qty} ${card.name}\n` : `${card.name}\n`
    }

    try {
      navigator.clipboard.writeText(text)

      ToastService.create('Card names copied', 'Deck Comparison', 'success')
    } catch {
      ToastService.create('Failed to copy card names', 'Deck Comparison')
    }
  }

  return (
    <CollapsibleContentContainer
      name={`${name} (${listLength})`}
      defaultCollapsed={defaultCollapsed}
      className={styles.collapsableContainer}>
      <div className={styles.header}>
        <h3 className={styles.headerName}>{`${name} (${listLength})`}</h3>
        {!!cards && (
          <ArchidektDropdown
            menuClassName={styles.options}
            options={[
              { label: 'Copy card names', onClick: () => handleCopyCardNames(false), icon: 'copy' },
              {
                label: 'Copy card names (qty)',
                onClick: () => handleCopyCardNames(true),
                icon: 'copy',
                hidden: skipQuantities,
              },
              { type: 'spacer' },
              { label: 'Buy cards', onClick: () => setBulkBuyOpen(true), icon: 'shopping cart' },
            ]}
          />
        )}
        <div className={styles.colorSplotches}>
          <span>
            <span className={styles.aSplotch} />
            {deckAName}
          </span>
          <span>
            <span className={styles.bSplotch} />
            {deckBName}
          </span>
        </div>
      </div>
      <div className={className}>{children}</div>

      <BuyBulkModal open={bulkBuyOpen} onClose={() => setBulkBuyOpen(false)} preSelectedCards={cards} />
    </CollapsibleContentContainer>
  )
}

export default ContentBlock
